import React, { useState, useEffect } from 'react';
import { Table, Spin, Button, Row, Col, Input } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { getExpenditureListingData } from '../../../../Expenditures/ducks/actions.js';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const antIcon = <LoadingOutlined spin />;

export default (props) => {
  const { currentStep, setCurrentStep, startDate, endDate, reportId } = props;
  const [loading, setLoading] = useState(false);
  const expenditureListData = useSelector((state) => state.expenditure.expenditureListData);
  const dispatch = useDispatch();
  const history = useHistory();
  const urlID = history.location.pathname.split('/')[3];
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [dataSource, setDataSource] = useState();
  const [value, setValue] = useState('');
  useEffect(() => {
    dispatch(getExpenditureListingData(startDate, endDate));
  }, [startDate, endDate]);

  const listColumns = [
    {
      title: 'Date',
      dataIndex: 'date',
      render: (text) => moment(text).format('MM-DD-YYYY'),
      sorter: (a, b) => +moment(a.date, 'MM-DD-YYYY').format('X') - +moment(b.date, 'MM-DD-YYYY').format('X'),
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      sorter: (a, b) => +a.amount.replace('$', '').split(',').join('') - +b.amount.replace('$', '').split(',').join(''),
    },
    {
      title: 'Expenditure Type',
      dataIndex: 'type',
      sorter: (a, b) => a.type.localeCompare(b.type),
      render: (text) => <span className="text-capitalize">{text ? text.replace(/_/g, ' ') : '-'}</span>,
    },
    {
      title: 'Payee',
      dataIndex: 'payee',
      sorter: (a, b) => a.payee.localeCompare(b.payee),
    },
    {
      title: 'Form',
      dataIndex: 'payment_type',
      sorter: (a, b) => a.payment_type.localeCompare(b.payment_type),
      render: (text) => <span className="text-capitalize">{text ? text.replace(/_/g, ' ') : '-'}</span>,
    },
    {
      title: 'Account Code',
      dataIndex: 'bankaccount',
      sorter: (a, b) => a.bankaccount.localeCompare(b.bankaccount),
    },
  ];

  const moveToNextStep = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setCurrentStep(currentStep + 1);
    }, 1200);
  };

  const fetchData = (params = {}, fromDate = 'null', toDate = 'null') => {
    setLoading(true);
    fetch(``).then(({ results }) => {
      setPagination({
        ...params.pagination,
      });
    });
  };

  useEffect(() => {
    fetchData({
      pagination,
    });
  }, []);

  const handleTableChange = (newPagination, filters) => {
    fetchData({
      pagination: newPagination,
      ...filters,
    });
  };

  useEffect(() => {
    setDataSource(expenditureListData);
    setLoading(true);
    if (expenditureListData) {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  }, [expenditureListData]);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <Row>
        <Col className="search_box" style={{ margin: '0 24px 24px' }}>
          <Input
            placeholder="Search..."
            value={value}
            onChange={(e) => {
              const currValue = e.target.value.toLowerCase();
              setValue(currValue);
              const filteredData = expenditureListData.filter(
                (entry) =>
                  (entry?.date && entry?.date.includes(currValue)) ||
                  (entry?.amount && entry?.amount.includes(currValue)) ||
                  (entry?.type && entry?.type.toLowerCase().includes(currValue)) ||
                  (entry?.payee && entry?.payee.toLowerCase().includes(currValue)) ||
                  (entry?.payment_type && entry?.payment_type.toLowerCase().includes(currValue)) ||
                  (entry?.bankaccount && entry?.bankaccount.toLowerCase().includes(currValue)),
              );
              setDataSource(filteredData);
            }}
          />
        </Col>
      </Row>
      <Table columns={listColumns} dataSource={dataSource} pagination={pagination} onChange={handleTableChange} />
      <Row align="middle" justify="center" gutter={[20, 20]} style={{ marginTop: '100px' }}>
        <Col>
          <Button
            type="primary"
            onClick={() => setCurrentStep(currentStep - 1)}
            htmlType="button"
            className="font-gilroy white-btn"
            size="large"
          >
            Back
          </Button>
        </Col>

        <Col>
          <Button
            type="primary"
            onClick={() => moveToNextStep()}
            htmlType="button"
            className="font-gilroy"
            size="large"
          >
            Continue
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};
